// extracted by extract-css-chunks-webpack-plugin
module.exports = {"label":"css-2h5Pa8ygbz","label__error":"css-atrxsx6lsp","input":"css-3AUOLAW7EG","input_errorText":"css-GRcNTyAPTB","input__error":"css-11nHai6gFS"};